import { downloadBlob } from './blob'
import type { SheetInput } from './types'

/** RFC-4180 §2.6: a field is quoted when it holds the delimiter, a quote, or a line break. */
const NEEDS_QUOTES = /[",\r\n]/u
/** RFC-4180 §2.1: records are delimited by CRLF. */
const RECORD_SEPARATOR = '\r\n'
const MIME_TYPE = 'text/csv;charset=utf-8'

function csvValue(value: unknown): string {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : ''
  if (typeof value === 'boolean') return String(value)
  if (value instanceof Date) return Number.isFinite(value.getTime()) ? value.toISOString() : ''
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

function csvField(value: unknown): string {
  const text = csvValue(value)
  return NEEDS_QUOTES.test(text) ? `"${text.replace(/"/gu, '""')}"` : text
}

function getSafeCsvFilename(value: string): string {
  return `${value.replace(/\.csv$/iu, '')}.csv`
}

/**
 * Dependency-free RFC-4180 writer — the light table export that never pulls a vendor in.
 * Header row first, then data rows in column order; empty `data` yields a header-only file.
 */
export async function exportCsv(sheet: SheetInput, filename: string): Promise<void> {
  const header = sheet.columns.map((column) => csvField(column.header))
  const rows = sheet.data.map((row) => sheet.columns.map((column) => csvField(row[column.field])))
  const csv = [header, ...rows].map((cells) => cells.join(',')).join(RECORD_SEPARATOR)
  downloadBlob(new Blob([csv], { type: MIME_TYPE }), getSafeCsvFilename(filename))
}
